





































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import showFilesModal from '../components/showFiles.vue';
import { Spinner } from 'vue-image-spinner2';
import { asyncForEach } from '@/utils';
import Pica from 'pica';


    @Component({
    name: 'banner-home-modal',
    components: {
        showFilesModal,
        Spinner,
    },
    computed: {
        ...mapState('bannerHomes', ['activeBannerHomeLoading', 'activeBannerHome']),
        ...mapState('bannerHomes', ['allBannerHomes']),
        ...mapState('auth', ['currentUser']),
    },
})
export default class BannerHomeModal extends Vue {
    //
    public activeBannerHome!: any;
    public activeBannerHomeLoading!: any;
    public allBannerHomes!: any;
    public file_type: any = '';
    private currentUser!: any;
    public titleCharacterCountName: number = 0;
    public titleCharacterCountTitle: number = 0;
    public titleCharacterCountSubtitle: number = 0;
    public titleCharacterCountContent: number = 0;

    mounted() {
        this.$root.$on('bv::modal::show', (bvEvent: any, modalId: string) => {
            if (modalId === 'banner-home-modal') {
                this.updateTitleCharacterCount(this.activeBannerHome.name, 1);
                this.updateTitleCharacterCount(this.activeBannerHome.cover_title, 2);
                this.updateTitleCharacterCount(this.activeBannerHome.cover_subtitle, 3);
                this.updateTitleCharacterCount(this.activeBannerHome.cover_content, 4);
            }
        });
    }

    @Watch('activeBannerHome.name')
    onCoverNameChange(newVal: string) {
        this.updateTitleCharacterCount(newVal, 1);
    }

    @Watch('activeBannerHome.cover_title')
    onCoverTitleChange(newVal: string) {
        this.updateTitleCharacterCount(newVal, 2);
    }

    @Watch('activeBannerHome.cover_subtitle')
    onCoverSubtitleChange(newVal: string) {
        this.updateTitleCharacterCount(newVal, 3);
    }

    @Watch('activeBannerHome.cover_content')
    onCoverContentChange(newVal: string) {
        this.updateTitleCharacterCount(newVal, 4);
    }


    canSee(roles: any) {
        return _.intersection(roles, [this.currentUser.role.name]).length > 0;
    }

    onSaveBannerHome() {
        
        console.log(this.activeBannerHome);
        
        this.$store.dispatch('bannerHomes/postOne', {
            vm: this,
            data: this.activeBannerHome
            });
        
    }

    async onFileChange(e: any) {
        setTimeout(() => {
            // console.log({ file_type: this.file_type });
        }, 2000);
        if(this.file_type == this.file_type)
        switch (this.file_type) {
            case 'featured':
                console.log(e.target)
                if (e.target) {
                    const files = e.target.files;
                    await asyncForEach(files, async (file: any) => {
                        if (!file) return;
                        try {
                            // convert original file to webp
                            const resizedFile: any = await this.resizeImage(file, 0, 0, 'featured');
                            this.activeBannerHome.image = this.formatFile(resizedFile, '', '');
                            console.log({data: this.activeBannerHome});
                        } catch (error) {
                            console.error('Error resizing image:', error);
                        }
                    });
                } else {
                    this.activeBannerHome.image = {
                        id: e.id,
                        sort: null,
                        url: `https://directus.prodelec.app/assets/${e.id}`,
                        origin: 'directus-update',
                        file: null,
                    };
                }
                break;
            default:
                console.log('Img progress...');
                break;
        }
    }

    resizeImage(file: any, width: any, height: any, type: string) {
        return new Promise((resolve, reject) => {
            const pica = new Pica();
            const img = new Image();
            img.onload = async () => {
                try {
                    if (type == 'featured') {
                        if (img.width >= 3000 && img.height >= 2000) { 
                            const resizedCanvas = document.createElement('canvas');
                            width == 0 ? (resizedCanvas.width = img.width) : (resizedCanvas.width = width);
                            height == 0 ? (resizedCanvas.height = img.height) : (resizedCanvas.height = height);
                            const resizeOptions = {
                                filter: 'mks2013',
                            };
                            await pica.resize(img, resizedCanvas, resizeOptions);
                            resizedCanvas.toBlob((blob) => {
                                const resizedFile = new File([blob], file.name, { type: 'image/webp' });
                                resolve(resizedFile);
                            }, 'image/webp');
                       } else {
                            this.activeBannerHome.image = '';
                            this.$bvToast.toast('Lo sentimos, la imagen no cumple con las dimensiones mínimas (3000x2000)', {
                                title: `Imagen no válida`,
                                variant: 'warning',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                            return false;
                        }
                    }
                } catch (error) {
                    reject(error);
                }
            };
            img.src = URL.createObjectURL(file);
        });
    }

    formatFile(resizedFile: any, width: any, height: any) {
        let file_name = resizedFile.name.split('.')[0];
        
        file_name = file_name + '_' + width + 'x' + height;
        let formData = new FormData();
        formData.append('title', file_name);
        formData.append('image', resizedFile, resizedFile.name);
        return {
            id: uuidv4(),
            sort: null,
            url: URL.createObjectURL(resizedFile),
            origin:'upload',
            file: formData,
            name: file_name,
        };
    }

    onOpenFilesModal(file_type: string) {
        this.file_type = file_type;
        setTimeout(() => {
            this.$bvModal.show('show-files-modal');
        }, 400);
    }

    setFileType(file_type: string) {
        this.file_type = file_type;
    }

    updateTitleCharacterCount(value: string, title: number) {
        switch (title) {
            case 1:
                this.titleCharacterCountName = value.length;
            break;

            case 2:
                this.titleCharacterCountTitle = value.length;
            break;

            case 3:
                this.titleCharacterCountSubtitle = value.length;
            break;

            case 4:
                this.titleCharacterCountContent = value.length;
            break;
        }
    }
    
}
